import { createConsola } from "consola";

export class Logging {
  private static logger = createConsola();

  public static info = (message: string, ...args: any[]): void => {
    this.logger.info(message, ...args);
  };

  public static error = (message: string, ...args: any[]): void => {
    this.logger.error(message, ...args);
  };

  public static warn = (message: string, ...args: any[]): void => {
    this.logger.warn(message, ...args);
  };

  public static fatal = (message: string, ...args: any[]): void => {
    this.logger.fatal(message, ...args);
  };

  public static debug = (message: string, ...args: any[]): void => {
    this.logger.debug(message, ...args);
  };

  public static success = (message: string, ...args: any[]): void => {
    this.logger.success(message, ...args);
  };
}
